/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useContext } from "react";
// import { useUpdateModel } from 'hooks/use-update-model'
import { ModelContext } from "cms/models/context/provider";

const useModel = () => {

    const Model = useContext(ModelContext);
    const { state: ModelState, dispatch: ModelDispatch } = Model;

    const initFieldItem = (name, value) => {
        ModelDispatch({ type: "SET_FIELD_ITEM", name, value });
    };
    // const updateModel = useUpdateModel()

    // /**
    //  * @deprecated
    //  * Temporary wrapper for useUpdateModel
    //  */
    // const handleUpdateField = useCallback(
    //     (field) => updateModel({ field }),
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    //     []
    // )

    return {
        ModelState,
        ModelDispatch,
        initFieldItem,
        // handleUpdateField,
    };
};

export { useModel };
